import { Injectable } from '@angular/core';
import _ from 'lodash';
import { ApiService } from '../api/api.service';
import { INutrientSlurryPlanExportAndAdjustment } from './nutrient-slurry-plan-export-and-adjustment.model';

@Injectable()
export class NutrientSlurryPlanExportAndAdjustmentService {
  constructor(private apiService: ApiService) {}

  saveNutrientSlurryPlanExportAndAdjustment(
    nutrientSlurryPlanExportAndAdjustment: INutrientSlurryPlanExportAndAdjustment
  ): Promise<any> {
    if (_.isNil(nutrientSlurryPlanExportAndAdjustment))
      return Promise.resolve();

    return this.apiService.post(
      'v1/nutrient-slurry-plan-export-and-adjustments',
      nutrientSlurryPlanExportAndAdjustment
    );
  }
}
